// extracted by mini-css-extract-plugin
export var mclMultiLinePreviewStyles = "WO8ox";
export var noPreviewStyles = "ap3u6";
export var oneLinePreviewStyles = "SZaCC";
export var sclMultiLinePreviewStyles = "MVhy7";
export var twoLinePreviewStyles = "P8iGg";